import { AlertController, ToastController } from "ionic-angular";

import { EnvService } from "../environments/environment.factory";
import { HttpErrorResponse } from "@angular/common/http";
import { ProjectInterface as IProject } from "../models/interfaces/project.interface";
import { Injectable } from "@angular/core";

@Injectable()
export class Helper {
  private environment: any;

  constructor(
    private env: EnvService,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController
  ) {
    this.environment = env;
  }

  removeAttachment(db, docID, attID) {
    return db.get(docID).then((doc) => {
      db.removeAttachment(docID, attID, doc._rev);
    });
  }

  // TODO: refactor
  getProjectStatus(userEmail: string, project: IProject) {
    if (project.saved && !project.dirty) {
      return 1; // synced
    } else if (project.saved && project.dirty) {
      return 2; // not synced
    } else if (!project.saved) {
      return 3; // not saved
    }

    return -1;
  }

  projectExportLink(apiToken: string, id: number) {
    return `${this.environment.api}/v1/project/${id}/export?api_token=${apiToken}`;
  }

  projectArchiveLink(apiToken: string, id: number) {
    return `${this.environment.api}/v1/project/${id}/archive/download?api_token=${apiToken}`;
  }

  public diaProjectExportLink(apiToken: string, id: number, startDate: string, endDate: string) {
    return `${this.environment.api}/v1/project/dia-export?api_token=${apiToken}&dia_id=${id}&start_date=${startDate}&end_date=${endDate}`;
  }

  confirmLeave(isDirty: boolean): Promise<boolean> {
    return new Promise((resolve) => {
      if (!isDirty) {
        return resolve(true);
      }

      this.alertCtrl
        .create({
          title: "Bevestigen",
          message:
            "Het formulier bevat wijzigingen. Weet je zeker dat je pagina wilt verlaten?",
          buttons: [
            {
              text: "Verlaten",
              handler: () => {
                resolve(true);
              },
            },
            {
              text: "Blijven",
              handler: () => {
                resolve(false);
              },
            },
          ],
        })
        .present();
    });
  }

  showToast(message: string) {
    this.toastCtrl
      .create({
        message: message,
        duration: 5000,
        position: "top",
        showCloseButton: true,
        closeButtonText: "X",
      })
      .present();
  }

  public showSuccessfullySavedOnServer() {
    this.showToast("Project succesvol opgeslagen op server");
  }

  public checkIsOutOfSync(err: HttpErrorResponse): boolean {
    const errors = err.error.errors as {};

    if (errors["last_synced_at"]) {
      if (
        errors["last_synced_at"].indexOf(
          "The last sync date on the server is newer than the local one."
        ) !== -1
      ) {
        return true;
      }
    }

    return false;
  }
}



// WEBPACK FOOTER //
// ./src/services/helper.service.ts